import { useCallback, useState } from 'react';

export const PROJECTS_DENSITY_STORAGE_KEY = 'projects.isDense';

function getInitialIsDense(): boolean {
  try {
    return localStorage.getItem(PROJECTS_DENSITY_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function useProjectsDensity() {
  const [isDense, setIsDenseState] = useState<boolean>(getInitialIsDense);

  const setIsDense = useCallback((value: boolean) => {
    setIsDenseState(value);
    try {
      localStorage.setItem(PROJECTS_DENSITY_STORAGE_KEY, String(value));
    } catch {
      return;
    }
  }, []);

  return { isDense, setIsDense };
}
